import { gql } from "graphql-tag";

export const LIVESTREAM_SUB = gql`
  subscription LivestreamUpdated {
    livestreamUpdated {
      id
      battleType
      currentPlayer {
        id
        username
        avatar
      }
      game {
        id
        type
        title
        status
        description
        category
      }
      host {
        id
        username
        avatar
      }
      numberOfViewers
      status
    }
  }
`;
